import { formatPrice } from '@/helper/Numbers';
import { Text, ThemeText } from '@/components/Theme';

const FormatPrice = ({price = null, currency = null, ...rest}) => {
    
    const {
        themed = true
    } = rest ?? {};

    const ViewComp = themed ? ThemeText : Text;

    return (
        <ViewComp 
            variant={['h1', 'right']}
            style={{whiteSpace: 'nowrap'}} 
            {...rest}
        >
            {formatPrice(price, currency)}
        </ViewComp>
    )
}

export default FormatPrice;